import React, { createContext, useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Shop from '../entities/shop.entity';

interface ShopContextProps {
  shop: Shop | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setShop: React.Dispatch<React.SetStateAction<Shop | null>>;
  handleSelectShop: (newShop: Shop) => void;
  handleUnselectShop: () => void;
}

export const ShopContext = createContext<ShopContextProps>({} as ShopContextProps);

export const useShopContext = () => useContext(ShopContext);

export const ShopProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [shop, setShop] = useState<Shop | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelectShop = useCallback(
    (newShop: Shop) => {
      setShop(newShop);
      navigate(`/shops/${newShop.id}`);
    }, [navigate]);

  const handleUnselectShop = useCallback(() => {
    setShop(null);
    navigate('/shops');
  }, [navigate]);

  return (
    <ShopContext.Provider value={{ shop, loading, setLoading, setShop, handleSelectShop, handleUnselectShop }}>
      {children}
    </ShopContext.Provider>
  );
};
